// METIS Hub wording — namespace "labels" (en), 40 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/i18n.js App.labels (label dictionary, plan 9.2)).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const labels: Record<string, string> = {
  "label.conversation": "Conversation",
  "label.prompt": "Question",
  "label.aiAnswer": "AI answer",
  "label.contentText": "Question & answer text",
  "label.usage": "Usage (tokens)",
  "label.inputTokens": "Newly read",
  "label.cacheRead": "Read from cache",
  "label.cacheWrite": "Saved to cache",
  "label.outputTokens": "Written by AI",
  "label.reasoningTokens": "Thinking (included)",
  "label.model": "AI model",
  "label.effort": "Thinking depth",
  "label.activeTime": "AI active time",
  "label.sessionDuration": "Time the chat was open",
  "label.latency": "Wait time",
  "label.latencyTypical": "Typical",
  "label.latencySlow": "Slow",
  "label.toolCall": "Actions by AI",
  "label.filesOpened": "Files opened by AI",
  "label.filesEdited": "Files edited",
  "label.diff": "Changes",
  "label.toolDecision": "Allowed / Rejected",
  "label.usageMethod": "How used",
  "label.methodCli": "CLI tool",
  "label.methodApi": "API key call",
  "label.entrypoint": "Where it ran",
  "label.recordingLevel": "Recording level",
  "label.viewScope": "View scope",
  "label.auditLog": "Access & change log",
  "label.collectionStatus": "Collection status",
  "label.connect": "Connect tools",
  "label.quiet": "Quiet for a while",
  "label.estimatedCost": "Estimated cost",
  "label.roleAdmin": "Admin",
  "label.roleManager": "Manager",
  "label.roleMember": "Member",
  "label.contentReviewer": "Content reviewer",
  "label.logReviewer": "Log reviewer",
  "label.noRecord": "No record",
  "label.partial": "Partial",
};

export default labels;
